import React from "react";
import Navbar from "../components/Navbar";

export default function LandingPage() {
  return (
    <div className="landing_wrapper">
      <div className="banner">
        <div style={{ padding: "0rem 2rem" }}>
          <Navbar />
          <h1>
            Welcome to <span style={{ color: "#FFCA28" }}>Porch</span>
          </h1>
          <h2>Delivering great food for more than 10 years</h2>
          <div className="baner_links">
            <a>OUR MENU</a>
            <a>BOOK A TABLE</a>
          </div>
          <div className="location_search_wrapper">
            <div className="location_search">
              <div className="location">
                <i class="fa-solid fa-location-dot"></i>{" "}
                <span style={{ margin: "0px 15px" }}>Location</span>{" "}
                <i class="fa-solid fa-caret-down"></i>
              </div>
              <div className="search">
                Search{" "}
                <span>
                  <i class="fa-solid fa-magnifying-glass"></i>
                </span>
              </div>
            </div>
          </div>
          <div className="ratings_wrapper">
            <div className="rating">
              <span>
                20K+ <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star-half"></i>
                4.5 Star Rating
              </span>
            </div>
          </div>
        </div>
        <div className="blur_category_wrapper">
          <div className="cat_item">
            <img src="images/category 1.png" />
            <div className="category_des">
              <div>Sandwich</div>
              <div style={{ fontSize: "16px" }}>Rs. 129/-</div>
              <div
                style={{
                  padding: "2px 10px",
                  fontSize: "15px",
                  backgroundColor: "#ffffff35",
                  borderRadius: "5px",
                }}
              >
                Click Here <i class="fa-solid fa-caret-down"></i>
              </div>
            </div>
          </div>
          <div className="cat_item">
            <img src="images/category 2.png" />
            <div className="category_des">
              <div>Pizza</div>
              <div style={{ fontSize: "16px" }}>Rs. 129/-</div>
              <div
                style={{
                  padding: "2px 10px",
                  fontSize: "15px",
                  backgroundColor: "#ffffff35",
                  borderRadius: "5px",
                }}
              >
                Click Here <i class="fa-solid fa-caret-down"></i>
              </div>
            </div>
          </div>
          <div className="cat_item">
            <img src="images/category 3.png" />
            <div className="category_des">
              <div>Biryani</div>
              <div style={{ fontSize: "16px" }}>Rs. 129/-</div>
              <div
                style={{
                  padding: "2px 10px",
                  fontSize: "15px",
                  backgroundColor: "#ffffff35",
                  borderRadius: "5px",
                }}
              >
                Click Here <i class="fa-solid fa-caret-down"></i>
              </div>
            </div>
          </div>
          <div className="cat_item">
            <img src="images/category 4.png" />
            <div className="category_des">
              <div>Burgers</div>
              <div style={{ fontSize: "16px" }}>Rs. 129/-</div>
              <div
                style={{
                  padding: "2px 10px",
                  fontSize: "15px",
                  backgroundColor: "#ffffff35",
                  borderRadius: "5px",
                }}
              >
                Click Here <i class="fa-solid fa-caret-down"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="gallery_wrapper">
          <h1>Gallery</h1>
          <p>Lorem ipsum dolor sit amet consectetur.</p>

          <div className="gallery row">
            <div className="col-md-4 gallery_Img">
              <img
                style={{ maxWidth: "450px" }}
                src="images/Rectangle 7.png"
              ></img>
            </div>
            <div className="col-md-4 gallery_Img">
              <img
                style={{ maxWidth: "450px" }}
                src="images/Rectangle 8.png"
              ></img>
              <img
                style={{ maxWidth: "450px" }}
                src="images/Rectangle 9.png"
              ></img>
            </div>
            <div className="col-md-4 gallery_Img">
              <img
                style={{ maxWidth: "450px" }}
                src="images/Rectangle 10.png"
              ></img>
            </div>
          </div>
        </div>
      </div>
      <div className="review_wrapper">
        <div className="review_head">
          <h2>What people are saying about us.</h2>
        </div>
        <div className="review_body row">
          <div className="col-3">
            <img src="images/Ellipse 7.png" />
          </div>
          <div className="col-5 review">
            <p>
              Lorem ipsum dolor sit amet consectetur. Pellentesque feugiat ipsum
              duis amet ligula molestie tortor odio volutpat. Dignissim egestas
              sed sed proin rhoncus nunc vitae. Luctus augue ut integer eu leo.
              Aliquet sollicitudin odio consequat dignissim est ultrices magna.
              Varius risus.
            </p>
          </div>
        </div>
      </div>
      <div className="reservation_bg">
        <div className="reservation_wrapper container">
          <div className="row">
            <div className="col-md-8" style={{ padding: "4rem 2rem" }}>
              <h1>Online Reservation</h1>
              <p>booking request 9910402157 or fill out the order form</p>
              <div className="customer_detail_form row">
                <div className="col-6">
                  <input
                    className="customer_input"
                    type="text"
                    placeholder="Your Name"
                  ></input>
                </div>
                <div className="col-6">
                  <input
                    className="customer_input"
                    type="text"
                    placeholder="Phone Number"
                  ></input>
                </div>
                <div className="col-4">
                  <input
                    className="customer_input"
                    type="text"
                    placeholder="Phone Number"
                  ></input>
                </div>
                <div className="col-4">
                  <input
                    className="customer_input"
                    type="text"
                    placeholder="Phone Number"
                  ></input>
                </div>
                <div className="col-4">
                  <input
                    className="customer_input"
                    type="text"
                    placeholder="Phone Number"
                  ></input>
                </div>
                <div className="col-12">
                  <textarea
                    className="customer_input"
                    placeholder="Message"
                    rows="4"
                    cols="50"
                  ></textarea>
                </div>
                <div className="col-12">
                  <button className="book_table_btn">BOOK A TABLE</button>
                </div>
              </div>
            </div>
            <div className="col-md-4" style={{ padding: "0px" }}>
              <div className="contact_us_wrapper">
                <div className="bg_232323" style={{ padding: "2rem" }}>
                  <h1>Contact Us</h1>
                  <div className="social_icons">
                    <a
                      target="_blank"
                      href="https://www.facebook.com/The-Porch-Cafe-Restaurant-100352882761486"
                    >
                      <i
                        style={{ color: "white", fontSize: "25px" }}
                        class="fa-brands fa-facebook"
                      ></i>
                    </a>
                    <a target="_blank" href="http://instagram.com/_the.porch">
                      {" "}
                      <i
                        style={{ color: "white", fontSize: "25px" }}
                        class="fa-brands fa-instagram"
                      ></i>
                    </a>
                  </div>
                  <h2>Booking Request</h2>
                  <h3 style={{ fontSize: "32px" }}>+91 9024283004</h3>
                  <h2>Location</h2>
                  <h3>
                    Rooftop area, Hotel The Pride, 267, Rajeev Gandhi Nagar,
                    Kota, Rajasthan (324005)
                  </h3>
                  <h2>Email</h2>
                  <h3>porchcafeandrestaurant@gmail.com</h3>
                  <h2>Facilites</h2>
                  <div className="row">
                    <div className="col-6">
                      <ul className="facilities_list">
                        <li>Dining</li>
                        <li>Conference</li>
                        <li>Banquet</li>
                        <li>Parties (Birthday, Anniversary, Kitties)</li>
                      </ul>
                    </div>
                    <div className="col-6">
                      <ul className="facilities_list">
                        <li>Take Away</li>
                        <li>Fun, leisure activities</li>
                        <li>Wi-Fi</li>
                        <li>Ample parking space</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
